module.exports = __webpack_public_path__ + "static/img/wire_landing_03.436bcf4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/wire_landing_03.jpg
// module id = N0gw
// module chunks = 0